import React from "react";
import EventsTimeFilter from "../../../conversion-events/components/EventsTimeFilter";
import ChartTypeDropdown from "./ChartTypeDropdown";

/**
 * Shared report header: date range selector + chart type dropdown.
 * Same for Insight and Funnel; chart dropdown options come from reportType.
 * @param {"insight" | "funnel"} reportType
 * @param {object} timeFilterState - { selectedPreset, onTimeFilterChange } for EventsTimeFilter
 * @param {string} chartType - current chart type id
 * @param {(id: string) => void} onChartTypeChange
 * @param {object} theme - analytics theme
 */
export default function ReportHeader({
  reportType,
  selectedPreset,
  onTimeFilterChange,
  chartType,
  onChartTypeChange,
  theme,
}) {
  return (
    <div
      className="flex items-center gap-2 flex-1"
      style={{ fontFamily: "Raleway, sans-serif" }}
    >
      <EventsTimeFilter
        onTimeFilterChange={onTimeFilterChange}
        selectedPreset={selectedPreset}
      />
      <ChartTypeDropdown
        reportType={reportType}
        chartType={chartType}
        onChartTypeChange={onChartTypeChange}
        theme={theme}
      />
    </div>
  );
}
